// Proyeksi isometrik untuk tile 128x64 px (skala kota 2x)
// x,y = koordinat grid (tile), z = tinggi (px)
export const TILE_W = 128;
export const TILE_H = 64;

export const projectIso = (x, y, z = 0) => [
  (x - y) * (TILE_W / 2),
  (x + y) * (TILE_H / 2) - z
];

// Kebalikannya: dari koordinat layar (relatif pusat) ke grid
export const screenToGrid = (sx, sy) => {
  const gx = (sx / (TILE_W / 2) + sy / (TILE_H / 2)) / 2;
  const gy = (sy / (TILE_H / 2) - sx / (TILE_W / 2)) / 2;
  return [Math.floor(gx), Math.floor(gy)];
};
